import { DatePicker } from 'antd';
import { ComponentProps } from 'react';
import styled from 'styled-components';
import { STYLES } from 'utils/constants/styles';

type Props = ComponentProps<typeof DatePicker.RangePicker>;

const StyledPicker = styled(DatePicker.RangePicker)`
    border-radius: ${STYLES.BORDER_RADIUS};
    padding: ${STYLES.INPUT_PADDING};
    border-width: ${STYLES.BORDER_WIDTH};
`;

const RangePicker = (props: Props) => <StyledPicker suffixIcon={null} separator="|" {...props} />;

export default RangePicker;
